import { Link } from "react-router-dom";
import { CalendarCheck, Users } from "lucide-react";

const TABS = [
  { to: "/today", label: "Today", key: "today", Icon: CalendarCheck },
  { to: "/community", label: "Community", key: "community", Icon: Users },
];

export const MobileTabBar = ({ active }) => (
  <nav
    className="fixed inset-x-0 bottom-0 z-40 border-t border-[#E6E9EE] bg-white/95 backdrop-blur-sm"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    data-testid="mobile-tab-bar"
    aria-label="Primary"
  >
    <div className="mx-auto flex max-w-md">
      {TABS.map(({ to, label, key, Icon }) => {
        const on = active === key;
        return (
          <Link
            key={key}
            to={to}
            data-testid={`tab-${key}`}
            aria-current={on ? "page" : undefined}
            className={`flex min-h-[56px] flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-semibold transition-colors ${
              on ? "text-[#15816B]" : "text-[#8A94A6] hover:text-[#0B132B]"
            }`}
          >
            <Icon className="h-5 w-5" aria-hidden="true" />
            {label}
          </Link>
        );
      })}
    </div>
  </nav>
);

export default MobileTabBar;
